<template>
<section class="pt-8 pt-md-5 pb-8 pb-md-14">
    <div class="container">
        <div class="row">
            <div class="col-12">
                <h1 class="mb-0 fw-bold">Settings</h1>
                <p class="mb-6 text-muted" v-if="$state.context.id">
                    Please provide your Customer ID
                    <code>"{{ $state.context.id }}"</code>
                    when requesting support
                </p>
                <p class="mb-6 text-muted" v-else>
                    You can change the settings for your account here
                </p>
                <ul class="nav nav-tabs">
                    <li class="nav-item">
                        <a class="nav-link" :class="{'active': tab == 'profile'}" @click="tab = 'profile'" href="#profile">
                            Profile
                        </a>
                    </li>
                    <li class="nav-item">
                        <a class="nav-link" :class="{'active': tab == 'password'}" @click="tab = 'password'" href="#password">
                            Password
                        </a>
                    </li>
                    <li class="nav-item">
                        <a class="nav-link" :class="{'active': tab == 'security'}" @click="tab = 'security'" href="#security">
                            Security
                        </a>
                    </li>
                    <li class="nav-item">
                        <a class="nav-link" :class="{'active': tab == 'notifications'}" @click="tab = 'notifications'" href="#notifications">
                            Notifications
                        </a>
                    </li>
                    <li class="nav-item">
                        <a class="nav-link" :class="{'active': tab == 'apikey'}" @click="tab = 'apikey'" href="#apikey">
                            API Key
                        </a>
                    </li>
                    <li class="nav-item">
                        <router-link class="nav-link" :to="{path: '/settings/connected-apps'}">
                            Connected Apps
                        </router-link>
                    </li>
                </ul>
                <Profile v-if="tab == 'profile'" />
                <Password v-if="tab == 'password'" />
                <Security v-if="tab == 'security'" />
                <Notifications v-if="tab == 'notifications'" />
                <APIKey v-if="tab == 'apikey'" />
            </div>
        </div>
    </div>
</section>
</template>

<script>
import Tab from "../Tab"
import Profile from "./Profile"
import Password from "./Password"
import Security from "./Security"
import Notifications from "./Notifications"
import APIKey from "./APIKey"

export default {
    components: {
        Tab,
        Profile,
        Password,
        Security,
        Notifications,
        APIKey
    },
    data() {
        return {
            tab: location.hash.slice(1) || 'profile'
        }
    },
}
</script>
